"use client";

import type { ReactNode } from "react";

import { TRADE_CONFIRMATION_TIMEOUT } from "#/config/time";

// using absolute import will cause issues with the bundler
import { TradeConfirmationCheckbox } from "../../components/TradeConfirmationCheckbox/TradeConfirmationCheckbox";
import {
  type ReactNodeOrFunction,
  renderNodeOrFunction,
  showModal,
  type ShowModalOptions,
} from "./showModal";

export interface ConfirmTradeOptions {
  header: ReactNode;
  children: ReactNode;
  tradeButton: ReactNodeOrFunction;
}

export const confirmTrade = ({
  header,
  children,
  tradeButton,
}: ConfirmTradeOptions) => {
  const modalOptions: ShowModalOptions = {
    header,
    children,
    footer: ({ handleClose }) => (
      <div className="grid w-full gap-5">
        {renderNodeOrFunction(tradeButton, handleClose)}
        <TradeConfirmationCheckbox />
      </div>
    ),
    timeout: TRADE_CONFIRMATION_TIMEOUT,
  };

  showModal(modalOptions);
};
